(() => {
  const selector = 'a[href],button,input,select,textarea,[tabindex]';
  const previousTabIndex = new WeakMap();
  const suppressed = new Set();

  const restore = (control) => {
    const original = previousTabIndex.get(control);
    if (original === null) control.removeAttribute('tabindex');
    else control.setAttribute('tabindex', original);
    previousTabIndex.delete(control);
    suppressed.delete(control);
  };

  const syncHiddenFocus = () => {
    suppressed.forEach((control) => {
      if (!control.isConnected || !control.closest('[aria-hidden="true"]')) restore(control);
    });
    document.querySelectorAll('[aria-hidden="true"]').forEach((element) => {
      const controls = [...element.querySelectorAll(selector)];
      if (element.matches(selector)) controls.unshift(element);
      controls.forEach((control) => {
        if (!suppressed.has(control)) {
          previousTabIndex.set(control, control.getAttribute('tabindex'));
          suppressed.add(control);
        }
        if (control.getAttribute('tabindex') !== '-1') control.setAttribute('tabindex', '-1');
      });
    });
  };

  const start = () => {
    syncHiddenFocus();
    new MutationObserver(syncHiddenFocus).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
